export default "__VITE_ASSET__BJ4KZvui__"